import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent {
  tipo: string[] = [];
  titulo: string = "";
  mensaje: string = "";
  icono: string = "";
  abrirModal = false;

  constructor(private modalService: ModalService) {

    modalService.tipo$.subscribe((tipo) => {
      this.tipo = tipo;
    })
    modalService.titulo$.subscribe((titulo) => {
      this.titulo = titulo;
    })
    modalService.mensaje$.subscribe((mensaje) => {
      this.mensaje = mensaje;
    })
    modalService.icono$.subscribe((icono) => {
      this.icono = icono;
    })
    modalService.abrirModal$.subscribe((abrirModal) => {
      this.abrirModal = abrirModal;
    })
  }

  cerrarDialogoFinalizacion() {
    this.abrirModal = false;
    this.modalService.cerrarModal()
  }
}
